<template>
  <footer class="footer has-cards piePagina">
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">
            Gracias por su visita!
          </h3>
          <h4 class="mb-0 font-weight-light">Conoce más de mi aquí.</h4>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a
            target="_blank"
            href="https://www.facebook.com/diego.vallejo.52"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Like us"
          >
            <i class="fab fa-facebook-square"></i>
          </a>
          <a
            target="_blank"
            href="https://www.linkedin.com/in/dyego-vallejo-536945149/"
            class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fab fa-linkedin"></i>
          </a>
          <a
            target="_blank"
            href="https://github.com/dyeyo"
            class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Star on Github"
          >
            <i class="fab fa-github-square"></i>
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/dyegoyova/"
            class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fab fa-instagram-square"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            © 2020
            <a href="#" target="_blank">Diego Vallejo</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "fotter",
};
</script>

<style>
</style>